import { FssOpsToolCallRow } from "@mirage/mosaics/Chat/components/chat/ConversationMessages/ToolCalls/fss/FssToolCallRow";
import type {
  ParsedToolCall,
  ToolCallProgressStatus,
} from "@mirage/mosaics/Chat/components/chat/ConversationMessages/ToolCalls/types";
import { memo } from "react";

interface ToolCallRowProps {
  toolCall: ParsedToolCall;
  status: ToolCallProgressStatus | undefined;
}
export const ToolCallRow = memo(({ toolCall, status }: ToolCallRowProps) => {
  switch (toolCall.agentId) {
    case "fss_ops":
      return <FssOpsToolCallRow toolCall={toolCall} status={status} />;
    default:
      return null;
  }
});
ToolCallRow.displayName = "ToolCallRow";
